import React from 'react';
import { colors } from '@insurancemenu/imenu-components-lib';
import { BriefcaseMedical, Star, Tools } from '@insurancemenu/imenu-components-lib/dist/icons';
import { ProposalExperience } from 'store/modules/initiate-quote/types';
import {
  DescriptionBlockStyled,
  IconWrapperStyled,
  DescriptionBlockTitleStyled,
  DescriptionBlockDescriptionStyled,
  QuoteExperienceOptionStyled,
} from './styles';

interface OptionContent {
  label: string;
  description: string;
  icon: React.ReactNode;
  accentColor: string;
}

const QUOTE_EXPERIENCE_OPTION_MAP: Record<ProposalExperience, OptionContent> = {
  SHELF: {
    label: 'Create a Shelf Proposal',
    description: 'Build a proposal using predefined plans and standard options for a faster setup',
    icon: <BriefcaseMedical width="3rem" height="3rem" color={colors.green[600]} />,
    accentColor: colors.green[100],
  },
  FAVORITE: {
    label: 'Reuse a Favorite Proposal',
    description: 'Quickly create a new proposal from one of your saved favorite proposals and customize it as needed',
    icon: <Star width="3.4rem" height="3.4rem" color={colors.yellow[600]} />,
    accentColor: colors.yellow[100],
  },
  CUSTOM: {
    label: 'Initiate a Custom Proposal',
    description: "Build a customized proposal by requesting plan options tailored to your group's specific needs",
    icon: <Tools width="3rem" height="3rem" color={colors.purple[600]} />,
    accentColor: colors.purple[100],
  },
};

const QuoteExperienceOption: React.FC<{ experience: ProposalExperience }> = ({ experience }) => {
  const { label, description, icon, accentColor } = QUOTE_EXPERIENCE_OPTION_MAP[experience];

  return (
    <QuoteExperienceOptionStyled>
      <IconWrapperStyled $accentColor={accentColor}>{icon}</IconWrapperStyled>
      <DescriptionBlockStyled>
        <DescriptionBlockTitleStyled>{label}</DescriptionBlockTitleStyled>
        <DescriptionBlockDescriptionStyled>{description}</DescriptionBlockDescriptionStyled>
      </DescriptionBlockStyled>
    </QuoteExperienceOptionStyled>
  );
};

export default QuoteExperienceOption;
